import VueSocialSharing from 'vue-social-sharing'

export default async ({ Vue }) => {
  Vue.use(VueSocialSharing)
}
